import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx.js";

export function Card({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cx("rounded-lg border border-border bg-surface shadow-card", className)} {...rest}>
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  /** Nivel del encabezado para mantener la jerarquía de la página. */
  as?: "h2" | "h3";
}

export function CardHeader({ title, description, actions, className, as: H = "h2" }: CardHeaderProps) {
  return (
    <div className={cx("flex flex-wrap items-start gap-3 border-b border-border px-4 py-3", className)}>
      <div className="min-w-0 flex-1">
        <H className="text-[15px] font-semibold text-fg">{title}</H>
        {description && <div className="mt-0.5 text-[13px] text-muted">{description}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function CardBody({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cx("px-4 py-3", className)}>{children}</div>;
}

/** Cifra destacada (KPI) con etiqueta; el detalle opcional va en texto, no en color. */
export function Stat({ label, value, detail, icon }: { label: string; value: ReactNode; detail?: ReactNode; icon?: ReactNode }) {
  return (
    <Card className="px-4 py-3">
      <div className="flex items-center gap-1.5 text-[12.5px] font-medium text-muted [&>svg]:size-4">
        {icon}
        {label}
      </div>
      <div className="mt-1 text-2xl font-semibold tracking-tight text-fg tabular-nums">{value}</div>
      {detail && <div className="mt-0.5 text-[12.5px] text-subtle">{detail}</div>}
    </Card>
  );
}
